import { IUsers } from "./users.interface";

export interface ICoupons {
  id: number;
  name: string;
  type: CouponType;
  slug: string;
  code: string;
  description: string;
  minimum_transaction: number;
  quota: number;
  discount_type: DiscountType;
  discount: number;
  image: string;
  is_active: boolean;
  is_private: boolean;
  start_at: Date;
  users?: IUsers[] | null;
  end_at: Date;
}

export enum DiscountType {
  Nominal = "nominal",
  Percentage = "percentage",
}

export enum CouponType {
  Purchase = "purchase",
  Shipment = "shipment",
}

export interface ICouponCreate {
  image?: File;
  is_active: boolean;
  is_private: boolean;
  name: string;
  type: string;
  code: string;
  discount_type: string;
  discount: number;
  minimum_transaction: number;
  quota: number;
  start_at: Date;
  end_at: Date;
  description: string;
}
